import { styled } from '@linaria/react';

import { ButtonIconGhost } from '~shared/ui/molecules';
import { MqTablet } from '~theme/media';

export const StyledButton = styled(ButtonIconGhost)`
	&& {
		${MqTablet} {
			display: none;
		}
	}
`;
